module.exports = __webpack_public_path__ + "static/media/20ECE32.2c517ee4.jpg";